import { useRef, useState } from "react";

export const useCopyToClipboard = <T extends any[]>(fn: (...args: T) => string | undefined, ms = 1000) => {
  const [isCopied, setIsCopied] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const _fn = async (...args: T) => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    const text = fn(...args)
    if (!text) return;

    setIsCopied(true);

    await navigator.clipboard.writeText(text);
    timeoutRef.current = setTimeout(() => setIsCopied(false), ms);
  }

  return [_fn, isCopied] as const;
}